import { variant } from 'styled-system';

const fullWidthVariant = variant({
  prop: 'fullWidth',
  variants: {
    true: {
      width: '100%',
      flex: 'auto',
    },
  },
});

export default fullWidthVariant;
